import styled from "styled-components";

export const SpaceBetween = styled.div`
    padding-top: 20px;
    display: flex;
    justify-content: space-between;
`;
